import { useEffect, useState } from "react";
import { toast } from "sonner";
import { WifiOff, Wifi } from "lucide-react";

export const OfflineBanner = () => {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const onOnline = () => {
      setOnline(true);
      if (wasOffline) {
        toast.success("Back online", { icon: <Wifi size={14} /> });
        setWasOffline(false);
      }
    };
    const onOffline = () => {
      setOnline(false);
      setWasOffline(true);
      toast.warning("You're offline — showing cached content. Live comparisons won't work.", {
        icon: <WifiOff size={14} />,
        duration: 6000,
      });
    };
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, [wasOffline]);

  if (online) return null;
  return (
    <div
      data-testid="offline-banner"
      className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-black text-xs font-bold uppercase tracking-widest py-2 px-4 text-center inline-flex items-center justify-center gap-2"
    >
      <WifiOff size={12} /> Offline — viewing cached content
    </div>
  );
};
